// Global filters shared by every admin page.
// sportId === null means "All sports". Persisted by redux-persist (see index.js),
// so the admin's choice survives a page refresh.

export const SET_SPORT_FILTER = "SET_SPORT_FILTER";

export const setSportFilter = (sportId, sportName) => ({
  type: SET_SPORT_FILTER,
  payload: { sportId: sportId ?? null, sportName: sportName ?? null },
});

const initialState = {
  sportId: null,
  sportName: null,
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SPORT_FILTER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default filtersReducer;
